import React, { useState } from "react";
import { Table, Dropdown, Menu } from "antd";
import { CgExport } from "react-icons/cg";
import { BsThreeDots } from "react-icons/bs";
import ImageModal from "../Survelliance audit/IsoCertificationModal";
import RemainderModal from "../Survelliance audit/remainder modal/RemainderModal"
import ExportModal from "../Survelliance audit/export modal/ExportModal";


import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);



const ExpiredCertifications = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isRemainderVisible, setIsRemainderVisible] = useState(false);
  const [isExportVisible, setIsExportVisible] = useState(false);
  const [activeMenuItem, setActiveMenuItem] = useState(null);
  


   const [activeFilter, setActiveFilter] = useState("Monthly");

  const data = {
    labels: [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ],
    datasets: [
      {
        label: "Expired Certifications",
        data: [68, 75, 50, 28, 42, 90, 73, 65, 78, 40, 25, 80],
        backgroundColor: "#1cb4b4",
        borderRadius: 10,
        barThickness: 20,  
        maxBarThickness: 20,
        color:"grey"
      }
    ]
  };

  const options = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: "top",
      align: "start",
      labels: {
        boxWidth: 10,
        boxHeight: 10,
        color: "#333",
        padding: 20
      }
    },
     
  },
  scales: {
 y: {
  beginAtZero: true,
  suggestedMax: 90,
  ticks: {
    autoSkip: false,
    stepSize: 10,
    precision: 0,
    color: "#666",
    callback: function (value) {
      return value.toString().padStart(2, '0');
    }
  },
  grid: {
    color: "#eee",
    drawBorder: false
  }
},
  x: {
    ticks: {
      color: "#666"
    },
    grid: {
      display: false
    }
  }
}

};


  const filters = ["Daily", "Weekly", "Monthly"];



  // Dropdown menu click handler
  const handleActionClick = ({ key }) => {
    if (key === "view") {
      setIsModalVisible(true);
    } else if (key === "export") {
      setIsExportVisible(true);
    } else if (key === "reminder") {
      setIsRemainderVisible(true);
    }
  };

  const menu = (
  <Menu onClick={handleActionClick} className="expired-cert-dropdown-menu">
    {["view", "export", "reminder"].map((item) => (
      <Menu.Item
        key={item}
        className={`expired-cert-dropdown-item ${activeMenuItem === item ? "active" : ""}`}
        onClick={() => setActiveMenuItem(item)}  // Optional: update active item on click
      >
        {item.charAt(0).toUpperCase() + item.slice(1)}
      </Menu.Item>
    ))}
  </Menu>
);


  const columns = [
    {
      title: "Company Name",
      dataIndex: "companyname",
      key: "companyname",
    },
    {
      title: "Certification No",
      dataIndex: "certificationno",
      key: "certificationno",
    },
    {
      title: "Expiry Date",
      dataIndex: "expirydate",
      key: "expirydate",
    },
    {
      title: "Expired Since",
      dataIndex: "expiredsince",
      key: "expiredsince",
    },
    {
      title: "Renewal Status",
      dataIndex: "renewalstatus",
      key: "renewalstatus",
      render: (text) => {
        let color = text === "Not Contacted" ? "orange" : text === "In Progress" ? "red" : "black";
        return <span style={{ color }}>{text}</span>;
      },
    },
    {
  title: "Actions",
  key: "actions",
  render: () => (
    <Dropdown overlay={menu} trigger={["click"]} placement="bottomRight">
      <BsThreeDots style={{ fontSize: "20px", cursor: "pointer" }} />
    </Dropdown>
  ),
},
  ];

  const columndata = [
    {
      key: "1",
      companyname: "Levon techno",
      certificationno: "CERT-001",
      expirydate: "05-Mar-2024",
      expiredsince: "215 days",
      renewalstatus: "Not Contacted",
    },
    {
      key: "2",
      companyname: "Amazon",
      certificationno: "CERT-002",
      expirydate: "05-Mar-2026",
      expiredsince: "210 days",
      renewalstatus: "Not Contacted",
    },
    {
      key: "3",
      companyname: "Wipro",
      certificationno: "CERT-003",
      expirydate: "05-APR-2024",
      expiredsince: "230 days",
      renewalstatus: "Not Contacted",
    },
    {
      key: "4",
      companyname: "TCS",
      certificationno: "CERT-004",
      expirydate: "05-MAY-2025",
      expiredsince: "245 days",
      renewalstatus: "In Progress",
    },
    {
      key: "5",
      companyname: "Levon techno",
      certificationno: "CERT-001",
      expirydate: "05-Mar-2024",
      expiredsince: "215 days",
      renewalstatus: "Not Contacted",
    },
  ];

  return (
     <>
      <div className="reports-page">
      <div className="reports-table mt-3">
        <div className="d-flex justify-content-end align-items-center">
          <button className="reports-export-btn">
            <CgExport /> Export
          </button>
        </div>

        <div className="mt-4">
          <Table
            columns={columns}
            dataSource={columndata}
            pagination={{
              pageSize: Math.ceil(data.length / 2),
              total: data.length,
              className: "custom-pagination",
            }}
            scroll={{ x: "max-content" }}
          />
        </div>

      </div>
    </div>

     
     <div className="chart-container mt-4">
        <div className="chart-header">
          <div className="chart-title">Certification performance</div>
          <div className="chart-filters">
            {filters.map((filter) => (
              <button
                key={filter}
                className={`filter-button ${
                  activeFilter === filter ? "active" : ""
                }`}
                onClick={() => setActiveFilter(filter)}
              >
                {filter}
              </button>
            ))}
          </div>
        </div>
        <div className="bar-chart-wrapper">
          <Bar data={data} options={options} />
        </div>
      </div>


    {/* Modals */}
      <ImageModal visible={isModalVisible} onClose={() => setIsModalVisible(false)} />
      <RemainderModal visible={isRemainderVisible} onClose={() => setIsRemainderVisible(false)} />
      <ExportModal visible={isExportVisible} onClose={() => setIsExportVisible(false)} /> 
     </>
  );
};

export default ExpiredCertifications;
